import { addFullMarkCommand, removeFullMarkCommand, getMarkAttrs, isCustomMarkAllowed, insertNote, getNodeAttrs, setActiveTool } from "../../../commands/custom-commands";
import { validLinkTypes, customSchema } from "../../../schemas/custom-schema";

export default class CustomLinkTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--note-anchor";
    this.buttonElement.dataset.action = "link-note";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Nota";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Nota";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Nota";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--note-anchor";
    this.typeInput = document.createElement("select");
    this.typeInput.className = "editor-dropdown";
    validLinkTypes.map(({ value, label }) => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = label;

      return option;
    }).forEach(option => this.typeInput.appendChild(option));

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    this.removeButton = document.createElement("button");
    this.removeButton.type = "button";
    this.removeButton.className = "editor-button";
    this.removeButton.textContent = "Remover";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);
    buttonsContainer.appendChild(this.removeButton);

    this.dialogElement.appendChild(this.typeInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.removeAction = this.removeButtonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
    this.removeButton.addEventListener("click", this.removeAction);
  }

  update(view) {
    const markAttrs = getNodeAttrs(view.state, customSchema.nodes.note),
      isEnabled = insertNote("autor")(view.state, null, view);
    if(markAttrs) {
      this.buttonElement.setAttribute("aria-pressed", "true");
      this.removeButton.removeAttribute("disabled");
    } else {
      this.buttonElement.setAttribute("aria-pressed", "false");
      this.removeButton.setAttribute("disabled", "");
    }

    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.removeButton.removeEventListener("click", this.removeAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.typeInput = null;
    this.submitButton = null;
    this.removeButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
    this.removeAction = null;
  }

  removeButtonClickCallback() {
    return () => {
      this.typeInput.value = this.typeInput.options[0].value;
      removeFullMarkCommand(customSchema.marks.customLink)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: type } = this.typeInput;

      if(!validLinkTypes.map(attrs => attrs.value).includes(type)) {
        return false;
      }

      insertNote(type)(this.view.state, this.view.dispatch, this.view);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}